import { LoadingButton } from '@mui/lab';
import { Box, TextField, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useEffect, useState } from 'react';
import ForaDoHorarioAtendimento from '../../../components/ForaDoHorarioAtendimento';
import { sendNSerie } from '../../../services/checkout-service/sendNSerie';

export default function TelaNSerie({ navigate, setEmailMask, setNumSerie, initialNumSerie = '' }) {
  const theme = useTheme();
  const [numSerie, setCode] = useState('');
  const [loading, setLoading] = useState(false);
  const [erroMensagem, setErroMensagem] = useState('');

  useEffect(() => {
    if (initialNumSerie && !numSerie) {
      setCode(initialNumSerie);
    }
  }, [initialNumSerie, numSerie]);

  async function handleSendNSerie() {
    try {
      setLoading(true);
      if (numSerie !== '') {
        const resp = await sendNSerie(numSerie);

        setNumSerie(numSerie);
        setEmailMask(resp.data.emailMask);

        navigate(2);
      }
    } catch (error) {
      console.error(error);
      setErroMensagem('Numero de serie invalido');
    } finally {
      setLoading(false);
    }
  }

  const handleCodeChange = (e) => {
    if (erroMensagem) {
      setErroMensagem('');
    }
    if (e.target.value.length <= 6) {
      setCode(e.target.value);
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        textAlign: 'center',
      }}
    >
      <ForaDoHorarioAtendimento />

      <Typography variant="h5" component="h3" sx={{ color: theme.palette.error.main, mb: 2 }}>
        Voce esta offline
      </Typography>

      <Typography variant="body1" sx={{ color: theme.palette.text.secondary, mb: 2 }}>
        Informe o numero de serie do seu equipamento para iniciar o atendimento.
      </Typography>

      <TextField
        placeholder="Numero de serie"
        variant="outlined"
        size="medium"
        fullWidth
        type="number"
        value={numSerie}
        onChange={handleCodeChange}
        sx={{ mb: 1.5 }}
        error={!!erroMensagem}
        helperText={erroMensagem || ' '}
      />

      <Box
        sx={{
          mb: 1.5,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <img
          src="/static/imagensNSerie/etiqueta.png"
          alt="Etiqueta produto"
          style={{
            width: '100%',
            maxWidth: 250,
            height: 'auto',
          }}
        />
      </Box>

      <Typography
        variant="body2"
        sx={{
          color: theme.palette.text.disabled,
          textAlign: 'center',
          display: 'block',
          fontSize: '1rem',
          mb: 1.5,
        }}
      >
        Informe os 6 primeiros digitos do numero de serie.
      </Typography>

      <Box sx={{ mt: 1.5, display: 'flex', flexDirection: 'column', gap: 2, alignItems: 'center' }}>
        <LoadingButton
          loading={loading}
          disabled={numSerie.length < 6}
          variant="contained"
          fullWidth
          // eslint-disable-next-line react/jsx-no-bind
          onClick={handleSendNSerie}
        >
          Enviar
        </LoadingButton>
      </Box>
    </Box>
  );
}
